module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-dollar-05858927.svg";